// extracted by mini-css-extract-plugin
export default {"container":"MobileConfigurator__container___slRvV","inner":"MobileConfigurator__inner___Pim7D"};